import { useMemo } from 'react';
import { Path } from '@ninja/utilities';
import { IEidMembersForm } from '../../../with-eid-members';
import { IMembersForm } from '../../../without-eid-members/members-form/types';
import { usePlanCategoryField } from '../fields';

export const usePlanCategoryFieldsStructure = <TFormValues extends IEidMembersForm | IMembersForm>() => {
	const planCategoryField = usePlanCategoryField<TFormValues>({
		field: 'planCategoryId' as Path<TFormValues>,
	});
	const fieldsStructure = useMemo(() => [planCategoryField.getField()], [planCategoryField.getField]);

	return {
		fieldsStructure,
	};
};
